// extracted by mini-css-extract-plugin
export var downArrow = "_84-0";
export var label = "_84-1";
export var treatmentCard = "_84-3";
export var upArrow = "_84-2";